import { useState, useEffect } from 'react';
import Quiz from '../../quiz/pages/Quiz';
import PageMeta from '../../../components/PageMeta';
import HomeIntro from '../components/HomeIntro';
import { Box, CircularProgress } from '@mui/material';

const isSnapshotting = typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap');

export default function Home({ user, onUpdateUser }) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (!isSnapshotting) {
      setIsHydrated(true);
    }
  }, []);

  return (
    <>
      <PageMeta
        title="Harry Potter Trivia Quiz | The Quizzler"
        description="Free Harry Potter trivia for all levels — from casual fan to obsessive superfan. Compete on the leaderboard and find out where your loyalty lies."
        canonical="https://thequizzler.app"
      />
      <HomeIntro />
      {isHydrated ? (
        <Quiz user={user} onUpdateUser={onUpdateUser} />
      ) : (
        <Box display="flex" justifyContent="center" mt={8}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
}